module.exports = __webpack_public_path__ + "static/media/genderless.a77dc0cc.svg";